export default __webpack_public_path__ + "a16c32a54c4532a7543b2cf7bc34702e.svg";